import React from "react";
import { MessageCircle, Globe, Phone, Sparkles, HeartHandshake } from "lucide-react";
import { kitMeta } from "../electronicsKitData";

const SupportCtaSection = () => {
  return (
    <section className="section support-cta-section" id="support">
      <div className="container">
        <div className="support-card reveal-triggered zoom-in" data-aos="zoom-in">
          <div className="support-content">
            <div className="badge support-badge">
              <HeartHandshake size={16} /> Friendly Support
            </div>
            <h2>Need Help With a Project?</h2>
            <p>
              Stuck on a tricky connection or have a question about your kit? We are always happy to guide young inventors!
              Reach out to us directly on WhatsApp or explore our online robotics and AI classes.
            </p>

            <div className="support-actions">
              <a
                href={kitMeta.supportWhatsAppLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp-cta"
              >
                <MessageCircle size={20} />
                <span>WhatsApp Us: {kitMeta.supportPhone}</span>
              </a>

              <a
                href={kitMeta.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-website-cta"
              >
                <Globe size={18} />
                <span>Visit www.practido.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportCtaSection;
